import ModelBaseClass from "@quasidea/oas-client-react/lib/ModelBaseClass";
import RtReconciliationSearchUnmatchedRequest from "../RtReconciliationSearchUnmatchedRequest";
import ModelProxyClass from "./ModelProxyClass";


/**
 * @class RtReconciliationSearchUnmatchedRequestBase
 * @extends ModelBaseClass
 * @property {number} tenantId (int64)
 * @property {boolean} includeHiddenFlag
 * @property {Date} dateRangeStart (date only)
 * @property {Date} dateRangeEnd (date only)
 */
class RtReconciliationSearchUnmatchedRequestBase extends ModelBaseClass {
	/**
	 * @type {number} tenantId (int64)
	 */
	tenantId;
	/**
	 * @type {boolean} includeHiddenFlag
	 */
	includeHiddenFlag;
	/**
	 * @type {Date} dateRangeStart (date only)
	 */
	dateRangeStart;
	/**
	 * @type {Date} dateRangeEnd (date only)
	 */
	dateRangeEnd;

	/**
	 * Instantiates a new instance of RtReconciliationSearchUnmatchedRequest based on the generic object being passed in (typically from a JSON object)
	 * @param {object} genericObject
	 * @return {RtReconciliationSearchUnmatchedRequest}
	 */
	static create(genericObject) {
		const newRtReconciliationSearchUnmatchedRequest = new RtReconciliationSearchUnmatchedRequest();
		newRtReconciliationSearchUnmatchedRequest.instantiate(_modelDefinition, genericObject, ModelProxyClass.createByClassName);
		return newRtReconciliationSearchUnmatchedRequest;
	}

	/**
	 * Instantiates a new array of RtReconciliationSearchUnmatchedRequest based on the generic array being passed in (typically from a JSON array)
	 * @param {[object]} genericArray
	 * @return {[RtReconciliationSearchUnmatchedRequest]}
	 */
	static createArray(genericArray) {
		if (genericArray === null) {
			return null;
		}

		const newRtReconciliationSearchUnmatchedRequestArray = [];
		genericArray.forEach(genericObject => {
			newRtReconciliationSearchUnmatchedRequestArray.push(RtReconciliationSearchUnmatchedRequest.create(genericObject));
		});
		return newRtReconciliationSearchUnmatchedRequestArray;
	}
}

const _modelDefinition = [
	ModelBaseClass.createModelProperty('tenantId', 'integer'),
	ModelBaseClass.createModelProperty('includeHiddenFlag', 'boolean'),
	ModelBaseClass.createModelProperty('dateRangeStart', 'datetime'),
	ModelBaseClass.createModelProperty('dateRangeEnd', 'datetime'),
];

export default RtReconciliationSearchUnmatchedRequestBase;
